/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaFlujosEtapasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaFlujosEtapas: React.FunctionComponent<ITablaFlujosEtapasVistaProps & InjectedIntlProps> = ({
    flujosEtapass,
    consultarFlujosEtapas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <Tabla
        columns={columnas(intl.formatMessage)}
        data={flujosEtapass}
        actions={acciones(manejarFormulario, consultarFlujosEtapas, intl.formatMessage, confirmarEliminacion)}
        options={opciones}
    />
);

export default injectIntl(VistaFlujosEtapas);
